import MobilePickupDateTime from './commons/PickupDateTime/Mobile';
import MobileCruiseSelector from './commons/CruiseSelector/Mobile';
import MobileShipSelector from './commons/ShipSelector';
import builder from './builder.js';

export default builder({
  CruiseComponent: MobileCruiseSelector,
  ShipSelector: MobileShipSelector,
  DateTimeComponent: MobilePickupDateTime,
  mobile: true
});
